import { JSTheme } from '../../app/app.interface';

export const utradePlusTheme: JSTheme = {
    50: '#f2f5f7',
    100: '#e0e0e0',
    200: '#cad7e0',
    300: '#b5c7d3',
    400: '#a5bbc9',
    500: '#95afc0',
    600: '#8da8ba',
    700: '#829fb2',
    800: '#7896aa',
    900: '#67869c',
    A100: '#ffffff',
    A200: '#def1ff',
    A400: '#abdcff',
    A700: '#91d1ff',
    profit: '#1abc9c',
    loss: '#d63031',
    index: '#fff3cd',
    mtmloss2: '#ffbe76',
    contrast: {
        50: '#48494a',
        100: '#434343',
        200: '#3c4043',
        300: '#363b3f',
        400: '#31383c',
        500: '#2c3439',
        600: '#2a3437',
        700: '#272f35',
        800: '#242d33',
        900: '#d1dae1',
        A100: '#4c4c4c',
        A200: '#42484c',
        A400: '#33424c',
        A700: '#2b3e4c',
        profit: '#ffffff',
        loss: '#ffffff'
    }
};
